import React, { useRef, useState } from 'react'

//interfaces
import SelectItemList from  '@/components/elements/global/lists/SelectItemList/SelectItemList';

//component
import CaretButton from  '@/components/elements/global/buttons/CaretButton'


//hooks
import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';

export enum ListContributorViewOptions {
    AllItems = 'All Items',
    MyItems = 'My Items'
}

interface IViewToggleDrop {
    viewOption: ListContributorViewOptions,
    setViewOption:(view: ListContributorViewOptions) => void,
    buttonContent: any,
    buttonAriaLabel: string,
    className?: string
}

const ListItems = (currentSelection: ListContributorViewOptions) =>  {
    return [
        {
            content: 'All Items',
            isSelected: currentSelection === ListContributorViewOptions.AllItems,
            value: ListContributorViewOptions.AllItems
        },
        {
            content: 'My Items',
            isSelected: currentSelection === ListContributorViewOptions.MyItems,
            value: ListContributorViewOptions.MyItems
        },
]}



const ViewToggleDropdown = ({viewOption, setViewOption, buttonContent, buttonAriaLabel, className} : IViewToggleDrop) => {  
    const dropdownRef = useRef<any>()
    const [showDropdown, setShowDropdown] = useState<boolean>(false);

    const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.relatedTarget as Node)) {
          setShowDropdown(false);
        }
    };

    const handleCaretClick = () => {
        setShowDropdown(!showDropdown)
    }
    
    useClickAwayClose(showDropdown, dropdownRef, () => setShowDropdown(false));

    return(
        <div className={`caret-dropdown ${className}`} ref={dropdownRef} onBlur={handleBlur}>
            <CaretButton content={buttonContent} ariaLabel={buttonAriaLabel} onButtonClick={handleCaretClick}/>

            {showDropdown &&
                <SelectItemList items={ListItems(viewOption)} showCheckbox={false} handleClick={(i: number) => {setViewOption(ListItems(viewOption)[i].value); setShowDropdown(false) }}/>
            }
        </div>
    )
}

export default ViewToggleDropdown;